import React, { useState, useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks';
import { useTranslation } from 'react-i18next';
import useMediaQuery from '@mui/material/useMediaQuery';

// Components 

import Box from '@mui/material/Box';
import { updateDoctorPreferences } from '../../../routes/doctor/patients';
import InfoRow from '../../general/inputs/InfoRow';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import ToggleOffOutlinedIcon from '@mui/icons-material/ToggleOffOutlined';
import ToggleOnIcon from '@mui/icons-material/ToggleOn';
import { setNotificationMessage } from '../../../redux/features/general/notification';
import { setIsRefreshDoctorPreferences } from '../../../redux/features/doctor/Account/preferences';
import DataBox from '../../general/data/DataBox';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import EmailIcon from '@mui/icons-material/Email';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import getStatusColor from '../../../util/style/getStatusColor';
import BrowserUpdatedIcon from '@mui/icons-material/BrowserUpdated';
import HomeRepairServiceIcon from '@mui/icons-material/HomeRepairService';
import PasswordIcon from '@mui/icons-material/Password';
import Button from '../../general/inputs/Button';
import { setIsSecurityPinPopupOpened } from '../../../redux/features/general/navigation';

const Account: React.FC = () => {

  const dispatch = useAppDispatch(); 
  const { t } = useTranslation();
  
  const colors = useAppSelector(state => state.theme.colors); 
  const accountInfo = useAppSelector((state) => state.meta.accountInfo);
  const doctorPreferences = useAppSelector(state => state.doctorPreferences) as any; 
  const group = useAppSelector(state => state.doctorAccount.group); 
  const isMobile = useMediaQuery('(max-width:600px)');

  const [isLockScreenEnabled, setIsLockScreenEnabled] = useState(false); 

  const handleLockScreen = async () => { 

    const content = { 
      lockScreen: { 
        isEnabled: isLockScreenEnabled ? false : true, 
        isDisabled: isLockScreenEnabled ? true : false, 
      }
    }; 

    const res = await updateDoctorPreferences(content) as any;

    if (res.data.status == 200) { 

      dispatch(setIsRefreshDoctorPreferences(true)); 

      setIsLockScreenEnabled(res.data.doctorPreferences?.lockScreen?.isEnabled); 

    }; 


  }; 

  const handlePinUpdate = async () => { 

    dispatch(setIsSecurityPinPopupOpened(true)); 

  }; 

  // --

  useEffect(() => { 

    if (doctorPreferences) { 

      setIsLockScreenEnabled(doctorPreferences?.lockScreen?.isEnabled); 

    }; 

  },[doctorPreferences]); 

  // -- 

  return (

    <Box sx={{ 
        width: '100%',
        height: '100%',
        padding: isMobile ? '2vh 4vw' : '3vh 6vw',
        boxSizing: 'border-box',
        overflowY: 'scroll',
        scrollbarWidth: 'none',
    }}>

      <DataBox>

        <InfoRow 
          icon={<PasswordIcon sx={{ color: colors?.main }} />}
          title='securityPin'
          description={
            <Button 
              title='updatePin'
              triggerFunction={handlePinUpdate}
              extraStyle={{ padding: '2px 12px', marginTop: 0 }}
            />
          }
          handler={handleLockScreen}
        />

        <InfoRow 
          icon={<LockOpenIcon sx={{ color: colors?.main }} />}
          title='autoLock'
          description={isLockScreenEnabled ? <ToggleOnIcon sx={{ color: colors?.main }} /> : <ToggleOffOutlinedIcon sx={{ color: colors?.main }} />}
          handler={handleLockScreen}
        />

        <InfoRow 
          icon={<AccountCircleIcon sx={{ color: colors?.main }} />}
          title={'name'}
          description={`${accountInfo?.firstName} ${accountInfo?.lastName}`}
          isDisabled
        />

        <InfoRow 
          icon={<EmailIcon sx={{ color: colors?.main }} />}
          title='email'
          description={accountInfo?.email}
          isDisabled
        />

        <InfoRow 
          icon={<HomeRepairServiceIcon sx={{ color: colors?.main }} />}
          title='clinic'
          description={<Box sx={{ textAlign: 'right' }}>{group?.name}</Box>}
          isDisabled
        />

        <InfoRow 
          icon={<VerifiedUserIcon sx={{ color: colors?.main }} />}
          title='account'
          description={ <strong style={{ 
              padding: 5,
              borderRadius: 7,
              color: 'white', 
              backgroundColor: getStatusColor(accountInfo?.accountStatus), 
          }}>
              {t(accountInfo?.accountStatus)}
          </strong>}
          isDisabled
        />

        <InfoRow 
          icon={<BrowserUpdatedIcon sx={{ color: colors?.main }} />}
          title='version'
          description={accountInfo?.version}
          isDisabled
        />
      
      </DataBox>

    </Box>

  );

};

export default Account;